"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var _IndividualDetailsCard_personalDetails_accessor_storage, _IndividualDetailsCard_physicalCharacteristics_accessor_storage, _IndividualDetailsCard_contactInformation_accessor_storage, _IndividualDetailsCard_identification_accessor_storage, _IndividualDetailsCard_allowEditButton_accessor_storage, _IndividualDetailsCard_editView_accessor_storage, _IndividualDetailsCard_subTitle_accessor_storage, _IndividualDetailsCard_cardTitle_accessor_storage, _IndividualDetailsCard_includeCardTitle_accessor_storage;
Object.defineProperty(exports, "__esModule", { value: true });
exports.IndividualDetailsCard = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const individual_details_util_1 = require("../../../util/individual-details-util");
let IndividualDetailsCard = class IndividualDetailsCard extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        _IndividualDetailsCard_personalDetails_accessor_storage.set(this, individual_details_util_1.IndividualDetailsUtil.getEmptyPersonalInformation());
        _IndividualDetailsCard_physicalCharacteristics_accessor_storage.set(this, individual_details_util_1.IndividualDetailsUtil.getEmptyPhysicalCharacteristics());
        _IndividualDetailsCard_contactInformation_accessor_storage.set(this, individual_details_util_1.IndividualDetailsUtil.getEmptyContactInformation());
        _IndividualDetailsCard_identification_accessor_storage.set(this, individual_details_util_1.IndividualDetailsUtil.getEmptyIdentification());
        _IndividualDetailsCard_allowEditButton_accessor_storage.set(this, true);
        _IndividualDetailsCard_editView_accessor_storage.set(this, false);
        _IndividualDetailsCard_subTitle_accessor_storage.set(this, '');
        _IndividualDetailsCard_cardTitle_accessor_storage.set(this, 'Individual Details');
        _IndividualDetailsCard_includeCardTitle_accessor_storage.set(this, true);
    }
    get personalDetails() { return __classPrivateFieldGet(this, _IndividualDetailsCard_personalDetails_accessor_storage, "f"); }
    set personalDetails(value) { __classPrivateFieldSet(this, _IndividualDetailsCard_personalDetails_accessor_storage, value, "f"); }
    get physicalCharacteristics() { return __classPrivateFieldGet(this, _IndividualDetailsCard_physicalCharacteristics_accessor_storage, "f"); }
    set physicalCharacteristics(value) { __classPrivateFieldSet(this, _IndividualDetailsCard_physicalCharacteristics_accessor_storage, value, "f"); }
    get contactInformation() { return __classPrivateFieldGet(this, _IndividualDetailsCard_contactInformation_accessor_storage, "f"); }
    set contactInformation(value) { __classPrivateFieldSet(this, _IndividualDetailsCard_contactInformation_accessor_storage, value, "f"); }
    get identification() { return __classPrivateFieldGet(this, _IndividualDetailsCard_identification_accessor_storage, "f"); }
    set identification(value) { __classPrivateFieldSet(this, _IndividualDetailsCard_identification_accessor_storage, value, "f"); }
    get allowEditButton() { return __classPrivateFieldGet(this, _IndividualDetailsCard_allowEditButton_accessor_storage, "f"); }
    set allowEditButton(value) { __classPrivateFieldSet(this, _IndividualDetailsCard_allowEditButton_accessor_storage, value, "f"); }
    get editView() { return __classPrivateFieldGet(this, _IndividualDetailsCard_editView_accessor_storage, "f"); }
    set editView(value) { __classPrivateFieldSet(this, _IndividualDetailsCard_editView_accessor_storage, value, "f"); }
    get subTitle() { return __classPrivateFieldGet(this, _IndividualDetailsCard_subTitle_accessor_storage, "f"); }
    set subTitle(value) { __classPrivateFieldSet(this, _IndividualDetailsCard_subTitle_accessor_storage, value, "f"); }
    get cardTitle() { return __classPrivateFieldGet(this, _IndividualDetailsCard_cardTitle_accessor_storage, "f"); }
    set cardTitle(value) { __classPrivateFieldSet(this, _IndividualDetailsCard_cardTitle_accessor_storage, value, "f"); }
    get includeCardTitle() { return __classPrivateFieldGet(this, _IndividualDetailsCard_includeCardTitle_accessor_storage, "f"); }
    set includeCardTitle(value) { __classPrivateFieldSet(this, _IndividualDetailsCard_includeCardTitle_accessor_storage, value, "f"); }
    createRenderRoot() {
        return this;
    }
    openEditView() {
        this.editView = !this.editView;
        this.requestUpdate();
    }
    handleEditIndividualDetails(event) {
        this.personalDetails = event.detail.personalDetails;
        this.physicalCharacteristics = event.detail.physicalCharacteristics;
        this.contactInformation = event.detail.contactInformation;
        this.identification = event.detail.identification;
        this.requestUpdate();
    }
    render() {
        return (0, lit_1.html) `
      <forge-card raised>
        <div style="display: flex; flex-direction: row; justify-content: space-between;">
          ${this.includeCardTitle
            ? (0, lit_1.html) `<div class="forge-typography--heading5" style="margin-bottom: 10px; font-weight: bold">
                ${this.cardTitle}
              </div>`
            : (0, lit_1.html) ``}
          ${this.allowEditButton
            ? (0, lit_1.html) `
                <forge-icon-button
                  slot="end"
                  aria-label="Edit individual details"
                  theme="primary"
                  density="medium"
                  @click=${this.openEditView}
                >
                  <forge-icon name=${this.editView ? 'content_save_outline' : 'square_edit_outline'}></forge-icon>
                  <forge-tooltip delay=${0}>${this.editView ? 'Save' : 'Edit'}</forge-tooltip>
                </forge-icon-button>
              `
            : (0, lit_1.html) ``}
        </div>
        <div>
          ${this.subTitle ??
            (0, lit_1.html) `<div .aria-label=${this.subTitle} class="forge-typography--body2" style="color: grey">
            ${this.subTitle}
          </div>`}
          ${this.includeCardTitle ? (0, lit_1.html) `<forge-divider style="margin-bottom: 10px;"></forge-divider>` : (0, lit_1.html) ``}
        </div>
        ${this.editView
            ? (0, lit_1.html) `
              <sup-individual-detail-edit
                .personalDetails=${this.personalDetails}
                .physicalCharacteristics=${this.physicalCharacteristics}
                .contactInformation=${this.contactInformation}
                .identification=${this.identification}
                .subTitle=${this.subTitle}
                @individualEditDetails=${this.handleEditIndividualDetails}
              ></sup-individual-detail-edit>
            `
            : (0, lit_1.html) `
              <sup-individual-detail-review
                .personalDetails=${this.personalDetails}
                .physicalCharacteristics=${this.physicalCharacteristics}
                .contactInformation=${this.contactInformation}
                .identification=${this.identification}
              ></sup-individual-detail-review>
            `}
      </forge-card>
    `;
    }
};
exports.IndividualDetailsCard = IndividualDetailsCard;
_IndividualDetailsCard_personalDetails_accessor_storage = new WeakMap();
_IndividualDetailsCard_physicalCharacteristics_accessor_storage = new WeakMap();
_IndividualDetailsCard_contactInformation_accessor_storage = new WeakMap();
_IndividualDetailsCard_identification_accessor_storage = new WeakMap();
_IndividualDetailsCard_allowEditButton_accessor_storage = new WeakMap();
_IndividualDetailsCard_editView_accessor_storage = new WeakMap();
_IndividualDetailsCard_subTitle_accessor_storage = new WeakMap();
_IndividualDetailsCard_cardTitle_accessor_storage = new WeakMap();
_IndividualDetailsCard_includeCardTitle_accessor_storage = new WeakMap();
__decorate([
    (0, decorators_js_1.property)({ type: Object })
], IndividualDetailsCard.prototype, "personalDetails", null);
__decorate([
    (0, decorators_js_1.property)({ type: Object })
], IndividualDetailsCard.prototype, "physicalCharacteristics", null);
__decorate([
    (0, decorators_js_1.property)({ type: Object })
], IndividualDetailsCard.prototype, "contactInformation", null);
__decorate([
    (0, decorators_js_1.property)({ type: Object })
], IndividualDetailsCard.prototype, "identification", null);
__decorate([
    (0, decorators_js_1.property)({ type: Boolean })
], IndividualDetailsCard.prototype, "allowEditButton", null);
__decorate([
    (0, decorators_js_1.property)({ type: Boolean })
], IndividualDetailsCard.prototype, "editView", null);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], IndividualDetailsCard.prototype, "subTitle", null);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], IndividualDetailsCard.prototype, "cardTitle", null);
__decorate([
    (0, decorators_js_1.property)({ type: Boolean })
], IndividualDetailsCard.prototype, "includeCardTitle", null);
exports.IndividualDetailsCard = IndividualDetailsCard = __decorate([
    (0, decorators_js_1.customElement)('sup-individual-details-card')
], IndividualDetailsCard);
